<template>
  <div :class="themeClass" class="app">
    <img :src="imageUrl" alt="Centered Image" class="centered-image" />
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      isDarkMode: false,
      imageUrl: "https://em-content.zobj.net/source/microsoft-teams/363/writing-hand_270d-fe0f.png",
    };
  },
  computed: {
    themeClass() {
      return this.isDarkMode ? "dark-mode" : "light-mode";
    },
  },
  created() {
    this.detectTheme();
    window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", this.detectTheme);
  },
  methods: {
    detectTheme() {
      this.isDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
    },
  },
  beforeUnmount() {
    window.matchMedia("(prefers-color-scheme: dark)").removeEventListener("change", this.detectTheme);
  },
};
</script>

<style scoped>
.app {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}

.centered-image {
  margin-bottom: 20px;
  max-width: 10%;
  max-height: 10%;
}

.dark-mode {
  background-color: black;
  color: white;
}

.light-mode {
  background-color: white;
  color: black;
}
</style>